module.exports = __webpack_public_path__ + "img/reactivate-campaign.a7abb2dd.svg";